var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticStyle:{"cursor":"pointer"},attrs:{"to":_vm.to,"tag":"span"}},[_c('v-img',{staticClass:"logo",attrs:{"src":_vm.emcomyLogo,"alt":"emcomy - Emergency Communicator","contain":"","max-width":"250"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }